<template lang="html">
  <div>
    <v-textarea
      :label="required != null ? (label + '*') : label"
      :rows="rows"
      :auto-grow="true"
      multi-line
      :counter="counter"
      :rules="couterRules"
      :required="required"
      :disabled="disabled"
      v-model="texto"
      @input="setTexto()"
    >
    </v-textarea>
  </div>
</template>

<script>
  export default {
    props: ['label', 'value', 'counter', 'rules', 'clearable', 'required', 'rows', 'disabled'],
    data: () => ({
      texto: ''
    }),
    computed: {
      couterRules: function () {
        let area = [
          (input) => (this.required === undefined) || !!input || 'Este campo é obrigatório',
          (input) => (this.counter === undefined) || (input == null || input.length <= this.counter) || 'Este campo não pode possuir mais que ' + this.counter + ' caracteres'
        ]
        return area
      }
    },
    watch: {
      value: {
        handler: function (val, oldVal) {
          this.texto = val
        },
        immediate: true
      }
    },
    methods: {
      setTexto () {
        this.$emit('input', this.texto)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// c-textarea.vue?ef498a6a